import React, { useState } from "react";
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ErrorPopup from "../components/ErrorPopup";
import SuccessPopup from "../components/SuccessPopup";
import Blob from '../assets/blob-hero.svg';


const Signup = () => {

    document.title = "Create an account | Lehumo";

    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    //Error Popup
    const [errorPopup, setErrorPopup] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    // Generate random strings
    const user_id = Math.random().toString(36).substring(2, 50);

    //User navigate to redirect to Bank Details Page
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();

        if (password === password2) {

            axios.post('http://localhost:5000/signup', {
                name: name,
                surname: surname,
                phone: phone,
                email: email,
                password: password,
                user_id: user_id
            })
                .then((response) => {
                    setSuccessMessage('Account Created');
                    setSuccessPopup(true);
                    navigate(`/BankDetails/${user_id}`);
                })
                .catch((error) => {
                    setErrorMessage('Details is already used');
                    setErrorPopup(true);
                });
        } else {
            setErrorMessage('Passwords do not match');
            setErrorPopup(true);
        }
    };


    return (
        <>
            <Container>
                <ErrorPopup trigger={errorPopup} setTrigger={setErrorPopup}>
                    <h3><span>☠️</span><br></br>{errorMessage}</h3>
                    <p>Please try again</p>
                    <center>
                        <button onClick={() => setErrorPopup(false)}>Close</button>
                    </center>
                </ErrorPopup>

                <SuccessPopup trigger={successPopup} setTrigger={setSuccessPopup}>
                    <h3><span>👍</span><br></br>{successMessage}</h3>
                    <center>
                        <Link to={`/BankDetails/${user_id}`}><button>Continue</button></Link>
                    </center>
                </SuccessPopup>

                <FormContainer>
                    <center>
                        <form onSubmit={handleSubmit}>
                            <h3>Sign up for a Lehumo account</h3>
                            <input type="text" name="name" placeholder="Your name" required value={name} onChange={(event) => setName(event.target.value)} />
                            <input type="text" name="surname" placeholder="Your surname" required value={surname} onChange={(event) => setSurname(event.target.value)} />
                            <input type="number" name="phone" placeholder="Phone number" required value={phone} onChange={(event) => setPhone(event.target.value)} />
                            <input type="email" name="email" placeholder="Email address" required value={email} onChange={(event) => setEmail(event.target.value)} />
                            <input type="password" name="password" placeholder="Password" minLength="8" required value={password} onChange={(event) => setPassword(event.target.value)} />
                            <input type="password" name="password2" placeholder="Confirm Password" minLength="8" required value={password2} onChange={(event) => setPassword2(event.target.value)} /><br />
                            <span>Use at least 8 characters for a strong password</span><br />
                            <p><Link to="TermsOfUse">By clicking next you accept the terms & conditions</Link></p>
                            <button type="submit" name="submit">Next</button>
                        </form>

                        <p>or register with your Google account</p>

                        <ExternalAccount>
                            <button className="google-btn"><i className="fa-brands fa-google"></i> Sign up with Google</button>
                        </ExternalAccount>

                        <Link to="/Login"><p>Already registered? Login</p></Link>
                    </center>
                </FormContainer>
            </Container>
        </>
    )
}

export default Signup

const Container = styled.div`
    background-image: linear-gradient(rgba(255, 246, 246, 0.2),rgba(255, 246, 246, 0.2)),url(${Blob});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: auto;
    display: flex;
    justify-content: center;
    align-item: center;

    
    @media (max-width: 900px) {
        background: var(--background);

    }
`

const FormContainer = styled.div`
    background: var(--background);
    width: 60%;
    height: 580px;
    margin: 100px auto;
    border-radius: 10px;
    justify-content: center;
    align-item: center;
    font-family: 'Poppins', sans-serif;
    box-shadow: rgba(99, 99, 99, 0.5) 0px 2px 8px 0px;

    p {
        margin-top: 30px;
        margin-bottom: 10px;
        font-size: 13px;
        font-weight: bold;

    }

    form {
        padding: 20px auto;

        p {
            font-size: 12px;
            margin: 10px auto;
            text-transform: uppercase;

            @media (max-width: 900px) {
                font-size: 10px;
            }
        }
    }

    input {
        border: 2px solid var(--primary);
        background: #fff;
        border-radius: 4px;
        width: 300px;
        height: 50px;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        outline: none;
        justify-content: space-between;
        margin-left: 2.5px;

        @media (max-width: 900px) {
            width: 300px;
            margin-left: 0;
        }
    }

       button {
        width: 600px;
        height: 50px;
        border-radius: 4px;
        background-color: var(--primary);
        border: 2px solid var(--primary);
        color: #fff;
        text-transform: uppercase;
        margin-top: 5px;
        font-weight: 600;
        font-size: 14px;

        :hover {
            background-color: transparent;
            border-radius: 30px;
            border: 2px solid var(--primary);
            color: var(--primary);
            transition: 0.2s ease-in-out;
        }

        @media (max-width: 900px) {
            width: 300px;
        }
    }

    h3 {
        padding-top: 30px;
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;

        @media (max-width: 900px) {
            text-align: center;
            margin-left: 0px;
        }
    }

    span {
        font-size: 11px;
        text-align: justify;
    }


    @media (max-width: 900px) {
        background: transparent;
        width: 95%;
        height: auto;
        margin: 50px auto;
        box-shadow: none;
    }

`

const ExternalAccount = styled.div`

.google-btn {
    background-color: transparent;
    border: 2px solid #000;
    color: #000;
    margin-top: 10px;
    width: 250px;
    text-transform: none;

    :hover {
        background-color: #efefef;
    }
}

`